// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__kqW6g","links":"Navbar_links__XTe1i","img":"Navbar_img__oF4Et"};